module.exports = __webpack_public_path__ + "img/bq-sa.843523ab.svg";